import { VictoryAxis, VictoryAxisProps } from 'victory';
import { Label } from './Label';
import { colors } from '@/uiPrimitives/color/colors.css';
import { axisFontStyle, fontStyle } from './cbsGraph.config';

const axisStyle: VictoryAxisProps['style'] = {
	axis: {
		stroke: colors.shape.positive.muted,
		strokeWidth: 1,
	},
	grid: {
		stroke: colors.shape.positive.muted,
		strokeWidth: ({ tick }: { tick?: number | string }) => (tick === 0 ? 0 : 1),
	},
};

export const Axis = ({
	labelText,
	tickLabelSpace = 0,
	...props
}: {
	labelText?: string | number;
	tickLabelSpace?: number;
} & VictoryAxisProps) => {
	return (
		<VictoryAxis
			tickLabelComponent={Label({
				style: [axisFontStyle, fontStyle],
			})}
			style={{
				...axisStyle,
				axisLabel: {
					...axisFontStyle,
					fontWeight: 'bold',
				},
			}}
			axisLabelComponent={Label({
				dy: tickLabelSpace,
				style: {
					...axisFontStyle,
					fontWeight: 'bold',
				},
			})}
			label={labelText}
			{...props}
		/>
	);
};
